import { useCallback, useState } from 'react'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { ISegments, ITrackConversionPair, TSourceChannel } from '../types'

export const useTrackConversionPair = () => {
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsTrackingConversionEnabled } = getFlag('fmsTrackingConversion')
  const [conversion, setConversion] = useState<ITrackConversionPair | undefined>({
    sourceChannel: undefined,
    sourceSegment: undefined,
  })

  /**
   * Dynamic pairing of channel and segment
   * @example setTrackConversion('email', 'lane_alert_cm_created')
   */
  const setTrackConversion = useCallback(
    <K extends TSourceChannel>(sourceChannel: K, sourceSegment: ISegments[K] | undefined): void => {
      if (isFmsTrackingConversionEnabled) setConversion({ sourceChannel, sourceSegment })
    },
    [setConversion, isFmsTrackingConversionEnabled]
  )

  const clearConversion = () => setConversion(undefined)

  return {
    conversion,
    setTrackConversion,
    setConversion,
    clearConversion,
  }
}
